import { render, staticRenderFns } from "./ModalRemocaoPapeis.vue?vue&type=template&id=30b559d2&scoped=true"
import script from "./ModalRemocaoPapeis.vue?vue&type=script&lang=js"
export * from "./ModalRemocaoPapeis.vue?vue&type=script&lang=js"
import style0 from "./ModalRemocaoPapeis.vue?vue&type=style&index=0&id=30b559d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b559d2",
  null
  
)

export default component.exports